export class Constants {
  public static readonly defaultMenus = {
    English: [
      {
        id: 'home',
        title: 'Home',
        url: '/site-master',
        icon: 'bosch-ic-home',
        code: 'HOME'
      },
      // {
      //   id: 'contactUs',
      //   title: 'Contact Us',
      //   url: '/dummy-link',
      //   icon: 'bosch-ic-call',
      //   code: 'CONTACT'
      // },
      // {
      //   id: 'advancedDashboard',
      //   title: 'Advanced Dashboard',
      //   url: '/dummy-link',
      //   icon: 'bosch-ic-desktop-dashboard',
      //   code: 'ADVD'
      // },
      {
        id: 'manage',
        title: 'Manage',
        url: '/dummy-link',
        icon: 'bosch-ic-clipboard',
        code: 'MNG',
        items: [
          {
            id: 'userManagement',
            title: 'User Management',
            url: 'user-management',
            code: 'USRMNG'
          },
          {
            id: 'ebyQBenchMarking',
            title: 'E/Q Benchmarking',
            url: 'sub-item-1',
            code: 'EQB'
          },
          {
            id: 'projectSettings',
            title: 'Project Settings',
            url: 'sub-item-2',
            code: 'PRJS'
          },
          {
            id: 'multiStepForms',
            title: 'Form',
            url: '/multi-step-form',
            code: 'FORM'
          },
          {
            id: 'manageReport',
            title: 'Manage Report',
            url: 'manage-report',
            code: 'MNGR'
          },
          {
            id: 'roleAndActivityManagement',
            title: 'User Role and Activity management',
            url: '/role-management',
            code: 'URAMNG'
          },
          {
            id: 'solarScheduler',
            title: 'Manage Solar Schedular',
            url: 'manage-solar-scheduler',
            code: 'MNGSS'
          },
          {
            id: 'preferences',
            title: 'Preferences',
            url: 'lang-change',
            code: 'PREF'
          }
        ]
      },
      {
        id: 'add',
        title: 'Add',
        url: '/dummy-link',
        icon: 'bosch-ic-document-add',
        code: 'ADD',
        items: [
          {
            id: 'addLoad',
            title: 'Add Load',
            url: 'add-load',
            code: 'ADDL'
          },
          // {
          //   'title': 'Add User',
          //   'url': 'add-user',
          //   'code': 'ADDU'
          // },
          {
            id: 'addMeter',
            title: 'Add Meter',
            url: 'add-meter',
            code: 'ADDM'
          },
          {
            id: 'addDCU',
            title: 'Add DCU',
            url: '/add-dcu',
            code: 'ADDD'
          },
          {
            id: 'addNode',
            title: 'Add Node',
            url: '/add-node',
            code: 'ADDN'
          },
          {
            id: 'addBuilding',
            title: 'Add Building',
            url: '/add-building',
            code: 'ADDB'
          }
        ]
      },
      {
        id: 'view',
        title: 'View',
        url: '/dummy-link',
        icon: 'bosch-ic-grid-view',
        code: 'VIEW',
        items: [
          {
            id: 'viewUsers',
            title: 'View Users',
            url: 'sub-item-0',
            code: 'VIEWU'
          },
          {
            id: 'myProfile',
            title: 'My Profile',
            url: 'sub-item-1',
            code: 'CHNP'
          },
          {
            id: 'viewRoles',
            title: 'View Roles',
            url: 'sub-item-2',
            code: 'VIEWR'
          },
          {
            id: 'viewSiteMaster',
            title: 'View Site Master',
            url: 'sub-item-2',
            code: 'VIEWSM'
          },
          {
            id: 'loadInventory',
            title: 'Load Inventory',
            url: 'load-inventory',
            code: 'LOADI'
          },
          {
            id: 'meterInventory',
            title: 'Meter Inventory',
            url: 'meter-inventory',
            code: 'MTRI'
          },
          {
            id: 'dcuInventory',
            title: 'DCU Inventory',
            url: 'dcu-inventory',
            code: 'DCUI'
          },
          {
            id: 'performanceMonitoring',
            title: 'Performance Monitoring',
            url: 'sub-item-2',
            code: 'PERM'
          },
          {
            id: 'serverHealth',
            title: 'Server Health',
            url: 'sub-item-2',
            code: 'SERVH'
          }
        ]
      },
      {
        id: 'report',
        title: 'Report',
        url: '/create-site-mat-table',
        icon: 'bosch-ic-analysis',
        code: 'REPORT',
        items: [
          {
            id: 'solarDailyReport',
            title: 'Solar Daily',
            url: '/solar-daily/solar',
            code: 'SOLARD'
          },
          {
            id: 'solarMonthlyReport',
            title: 'Solar Monthly',
            url: 'solar-monthly/solar',
            code: 'SOLARM'
          },
          // {
          //   id: 'energyDailyReport',
          //   title: 'Energy Daily',
          //   url: '/solar-daily/energy',
          //   code: 'ENERD'
          // },
          // {
          //   id: 'energyMonthlyReport',
          //   title: 'Energy Monthly',
          //   url: 'solar-monthly/energy',
          //   code: 'ENERM'
          // }
          {
            id: 'energyTreeExcel',
            title: 'Energy Report',
            url: 'energy-tree-excel',
            code: 'ENERTE'
          },
          {
            id: 'waterReport',
            title: 'Water Report',
            url: 'water-report',
            code: 'WATERER'
          },
          {
            id: 'airReport',
            title: 'Air Report',
            url: 'air-report',
            code: 'AIRER'
          },
          {
            id: 'gasReport',
            title: 'Gas Report',
            url: 'gas-report',
            code: 'GASER'
          }
        ]
      },
      {
        id: 'export',
        title: 'Export',
        url: '/create-site-mat-table',
        icon: 'bosch-ic-export',
        code: 'EXPORT',
        items: [
          {
            id: 'realtimeData',
            title: 'Realtime Energy Data',
            url: 'realtime-data',
            code: 'REALD'
          },
          {
            id: 'shiftWiseData',
            title: 'Shiftwise Data',
            url: 'sub-item-1',
            code: 'SHFTWD'
          },
          {
            id: 'solarPlantDailyReport',
            title: 'Solar Plant Daily Report',
            url: 'sub-item-2',
            code: 'SPDR'
          },
          {
            id: 'solarPlantMontyReport',
            title: 'Solar Plant Monthly Report',
            url: 'sub-item-2',
            code: 'SPMR'
          },
          {
            id: 'solarPlantCustomReport',
            title: 'Solar Plant Custom Duration Report',
            url: 'sub-item-2',
            code: 'SPCDR'
          },
          {
            id: 'peakDemandReport',
            title: 'Peak Demand Report',
            url: 'peak-demand-report',
            code: 'PEAKDR'
          }
        ]
      },
      {
        id: 'productionView',
        title: 'Production View',
        url: '/dummy-link',
        icon: 'bosch-ic-industry',
        code: 'PRODVW'
      },
      {
        id: 'help',
        title: 'Help',
        url: '/help',
        icon: 'bosch-ic-customerservice',
        code: 'HELP'
      }
    ],
    Japanese: [
      {
        id: 'home',
        title: 'ホーム',
        url: '/site-master',
        icon: 'bosch-ic-home',
        code: 'HOME'
      },
      // {
      //   id: 'contactUs',
      //   title: 'お問い合わせください',
      //   url: '/dummy-link',
      //   icon: 'Bosch-Ic-server',
      //   code: 'CONTACT'
      // },
      // {
      //   id: 'advancedDashboard',
      //   title: '高度なダッシュボード',
      //   url: '/dummy-link',
      //   icon: 'Bosch-Ic-server',
      //   code: 'ADVD'
      // },
      {
        id: 'manage',
        title: '管理',
        url: '/dummy-link',
        icon: 'bosch-ic-clipboard',
        code: 'MNG',
        items: [
          {
            id: 'userManagement',
            title: 'ユーザー管理',
            url: 'user-management',
            code: 'USRMNG'
          },
          {
            id: 'ebyQBenchMarking',
            title: 'E/Q ベンチマーク',
            url: 'sub-item-1',
            code: 'EQB'
          },
          {
            id: 'projectSettings',
            title: 'プロジェクトの設定',
            url: 'sub-item-2',
            code: 'PRJS'
          },
          {
            id: 'multiStepForms',
            title: 'フォーム',
            url: '/multi-step-form',
            code: 'FORM'
          },
          {
            id: 'manageReport',
            title: 'レポートの管理',
            url: 'manage-report',
            code: 'MNGR'
          },
          {
            id: 'roleAndActivityManagement',
            title: 'ユーザーロールとアクティビティの管理',
            url: '/role-management',
            code: 'URAMNG'
          },
          {
            id: 'solarScheduler',
            title: 'Solar Scheduler を管理します',
            url: 'manage-solar-scheduler',
            code: 'MNGSS'
          },
          {
            id: 'preferences',
            title: 'プリファレンス',
            url: 'lang-change',
            code: 'PREF'
          }
        ]
      },
      {
        id: 'add',
        title: '追加',
        url: '/dummy-link',
        icon: 'bosch-ic-document-add',
        code: 'ADD',
        items: [
          {
            id: 'addLoad',
            title: '荷重追加',
            url: 'add-load',
            code: 'ADDL'
          },
          // {
          //   'title': 'Add User',
          //   'url': 'add-user',
          //   'code': 'ADDU'
          // },
          {
            id: 'addMeter',
            title: 'メーターを追加します',
            url: 'add-meter',
            code: 'ADDM'
          },
          {
            id: 'addDCU',
            title: 'DCU を追加します',
            url: '/add-dcu',
            code: 'ADDD'
          },
          {
            id: 'addNode',
            title: 'ノードを追加します',
            url: '/add-node',
            code: 'ADDN'
          },
          {
            id: 'addBuilding',
            title: '建物を追加します',
            url: '/add-building',
            code: 'ADDB'
          }
        ]
      },
      {
        id: 'view',
        title: '表示',
        url: '/dummy-link',
        icon: 'bosch-ic-grid-view',
        code: 'VIEW',
        items: [
          {
            id: 'viewUsers',
            title: 'ユーザーを表示します',
            url: 'sub-item-0',
            code: 'VIEWU'
          },
          {
            id: 'myProfile',
            title: 'マイプロファイル',
            url: 'sub-item-1',
            code: 'CHNP'
          },
          {
            id: 'viewRoles',
            title: 'ロールの表示',
            url: 'sub-item-2',
            code: 'VIEWR'
          },
          {
            id: 'viewSiteMaster',
            title: 'サイトマスターを表示します',
            url: 'sub-item-2',
            code: 'VIEWSM'
          },
          {
            id: 'loadInventory',
            title: 'インベントリをロードします',
            url: 'load-inventory',
            code: 'LOADI'
          },
          {
            id: 'meterInventory',
            title: 'メーターインベントリ',
            url: 'meter-inventory',
            code: 'MTRI'
          },
          {
            id: 'dcuInventory',
            title: 'DCU のインベントリ',
            url: 'dcu-inventory',
            code: 'DCUI'
          },
          {
            id: 'performanceMonitoring',
            title: 'パフォーマンスの監視',
            url: 'sub-item-2',
            code: 'PERM'
          },
          {
            id: 'serverHealth',
            title: 'サーバーの正常性',
            url: 'sub-item-2',
            code: 'SERVH'
          }
        ]
      },
      {
        id: 'report',
        title: 'レポート',
        url: '/create-site-mat-table',
        icon: 'bosch-ic-analysis',
        code: 'REPORT',
        items: [
          {
            id: 'solarDailyReport',
            title: '太陽の日報',
            url: '/solar-daily/solar',
            code: 'SOLARD'
          },
          {
            id: 'solarMonthlyReport',
            title: '太陽月例',
            url: 'solar-monthly/solar',
            code: 'SOLARM'
          },
          // {
          //   id: 'energyDailyReport',
          //   title: 'エネルギー毎日',
          //   url: '/solar-daily/energy',
          //   code: 'ENERD'
          // },
          // {
          //   id: 'energyMonthlyReport',
          //   title: 'Energy 毎月のエネルギー',
          //   url: 'solar-monthly/energy',
          //   code: 'ENERM'
          // }
          {
            id: 'energyTreeExcel',
            title: 'エネルギーレポート',
            url: 'energy-tree-excel',
            code: 'ENERTE'
          },
          {
            id: 'waterReport',
            title: 'ウォーターレポート',
            url: 'water-report',
            code: 'WATERER'
          },
          {
            id: 'airReport',
            title: '空気 レポート',
            url: 'air-report',
            code: 'AIRER'
          },
          {
            id: 'gasReport',
            title: 'ガスレポート',
            url: 'gas-report',
            code: 'GASER'
          }
        ]
      },
      {
        id: 'export',
        title: 'エクスポート',
        url: '/create-site-mat-table',
        icon: 'bosch-ic-export',
        code: 'EXPORT',
        items: [
          {
            id: 'realtimeData',
            title: 'リアルタイムエネルギーデータ',
            url: 'realtime-data',
            code: 'REALD'
          },
          {
            id: 'shiftWiseData',
            title: 'データのシフト',
            url: 'sub-item-1',
            code: 'SHFTWD'
          },
          {
            id: 'solarPlantDailyReport',
            title: '太陽発電所日報',
            url: 'sub-item-2',
            code: 'SPDR'
          },
          {
            id: 'solarPlantMontyReport',
            title: '太陽発電所月次報告書',
            url: 'sub-item-2',
            code: 'SPMR'
          },
          {
            id: 'solarPlantCustomReport',
            title: 'ソーラープラントカスタム期間レポート',
            url: 'sub-item-2',
            code: 'SPCDR'
          },
          {
            id: 'peakDemandReport',
            title: 'ピーク需要レポート',
            url: 'peak-demand-report',
            code: 'PEAKDR'
          }
        ]
      },
      {
        id: 'productionView',
        title: 'プロダクションビュー',
        url: '/dummy-link',
        icon: 'bosch-ic-industry',
        code: 'PRODVW'
      },
      {
        id: 'help',
        title: 'ヘルプ',
        url: '/help',
        icon: 'bosch-ic-customerservice',
        code: 'HELP'
      }
    ]
  };

  public static readonly FABRIC = {
    ADD_NODE: {
      RECT: {
        BACKGROUND_COLOR: 'yellow'
      }
    }
  };
  public static readonly USER_ROLE = {
    USER: 'IEPSiteUser',
    ADMIN: 'IEPBoschAdmin',
    TECH_SUPPORT_L1: 'IEPBoschTechSupportL1',
    TECH_SUPPORT_L2: 'IEPBoschTechSupportL2',
    POWER_USER: 'IEPSitePowerUser',
    TECH_SUPPORT_L3: 'IEPBoschTechSupportL3',
    TECH_SUPPORT_L4: 'IEPBoschTechSupportL4',
    TECH_SUPPORT_L5: 'IEPBoschTechSupportL5',
    TECH_SUPPORT_L6: 'IEPBoschTechSupportL6',
    TECH_SUPPORT_L7: 'IEPBoschTechSupportL7',
    SITE_OWNER: 'IEPSiteOwner',
    MULTIPLE_SITE: 'IEPSiteUser',
    SINGLE_SITE: 'IEPTestRole',
    CUSTOM: 'SitePowerUser'
  };
  public static readonly DATE = {
    DATE_FORMAT: 'yyyy-MM-dd',
    DATE_FORMAT_MONTH: 'yyyy-MM',
    INSTANT_DATE_FORMAT: 'yyyy-MM-dd HH:mm:ss',
    INSTANT_DATE_FORMAT_START: 'yyyy-MM-dd 00:00:00',
    INSTANT_DATE_FORMAT_END: 'yyyy-MM-dd 23:59:59',
    HOURS_FORMAT: 'HH:mm:ss'
  };
  public static readonly MOMENT_DATE_FORMAT = {
    DATE_FORMAT: 'YYYY-MM-DD',
    DATE_FORMAT_MONTH: 'YYYY-MM',
    DAY_FORMAT: 'DD-MM-YYYY',
    FULL_DATE_FORMAT: 'DD-MM-YYYY HH:mm:ss',
    FULL_DATE_FORMAT_1: 'YYYY-MM-DD HH:mm:ss',
    FULL_DATE_FORMAT_2: 'DD-MM-YYYY HH:mm:ss',
    FULL_DATE_FORMAT_3: 'DD MMMM YYYY HH:mm:ss',
    FULL_DATE_FORMAT_ZONE: 'YYYY-MM-DDTHH:mm:ss.SSS[Z]',
    HOURS_FORMAT: 'HH:mm:ss',
    FULL_DATE_TIME_FORMAT: 'dddd, MMM D, H:mm:ss' // EEEE, MMM d, h:mm:ss
  };
  public static readonly DATE_RANGES_PROVIDER_FORMAT = {
    parse: {
      dateInput: 'YYYY-MM-DD'
    },
    display: {
      dateInput: 'YYYY-MM-DD',
      monthYearLabel: 'MMM YYYY',
      dateA11yLabel: 'YYYY-MM-DD',
      monthYearA11yLabel: 'MMMM YYYY'
    }
  };
  public static readonly DECIMAL_FORMAT = {
    ZERO_DECIMAL: 0,
    DECIMAL_NO: 2,
    SOLAR_DECIMAL_NO: 2,
    SOLAR_RO_DECIMAL_NO: 3,
    SOLAR_RO_COUNTER_DECIMAL_NO: 4
  };
  public static readonly ACTIVITY = {
    NEW_SITE: 'NSC',
    EDIT_SITE: 'ESD',
    VIEW_SITE: 'VSD',
    DELETE_SITE: 'DSD',
    NEW_USER: 'NSUC',
    EDIT_USER: 'ESUD',
    CHANGE_USER_PASSWORD: 'CSP',
    VIEW_USER: 'VSUD',
    VIEW_USER_PASSWORD: 'VSUP',
    DELETE_USER: 'DSU',
    CHANGE_USER_STATUS: 'CSOU',
    NEW_PROCESS: 'NPC',
    EDIT_PROCESS: 'EPD',
    VIEW_PROCESS: 'VPD',
    DELETE_PROCESS: 'DPD',
    NEW_LOAD: 'NLC',
    EDIT_LOAD: 'ELD',
    VIEW_LOAD: 'VLD',
    DELETE_LOAD: 'DL',
    NEW_DASHBOARD: 'NDC',
    EDIT_DASHBOARD: 'EDa',
    VIEW_DASHBOARD: 'VD',
    DELETE_DASHBOARD: 'DDa',
    VIEW_DASHBOARD_MASTER: 'VDaM',
    NEW_LOAD_2: 'NLC2',
    EDIT_LOAD_2: 'ELD2',
    VIEW_LOAD_SITE: 'VLDS',
    VIEW_DASHBOARD_MASTER_2: 'VDaM2',
    DELETE_LOAD_2: 'DL2',
    NEW_INVENTORY: 'NIR',
    EDIT_INVENTORY: 'EI',
    VIEW_INVENTORY: 'VI',
    DELETE_INVENTORY: 'DI',
    VIEW_INVENTORY_MASTER: 'VIM',
    NEW_ROLE: 'NRD',
    EDIT_ROLE: 'ERD',
    VIEW_ROLE_SITE: 'VRDS',
    DELETE_ROLE: 'DRD',
    VIEW_ROLE_MASTER: 'VRDM',
    NEW_DEFINITION: 'ND',
    EDIT_DEFINITION: 'EDe',
    VIEW_DEFINITION_SITE: 'VDS',
    DELETE_DEFINITION: 'DDe',
    VIEW_DEFINITION_MASTER: 'VDeM',
    STRATIFICATION_TANK_VIEW: 'STV',
    HYDRAULIC_UNIT_VIEW: 'HUV',
    TRANSFORMER_MONITORING_VIEW: 'TM',
    SOLAR_DASHBOARD_VIEW: 'SD',
    TESTBENCH_OVERVIEW: 'TO',
    LAYOUT_VIEW: 'LV',
    LOAD_ON_TREE_VIEW: 'LOTV',
    ENERGY_DASHBOARD: 'ED',
    REAL_TIME_INFORMATION: 'RTI',
    DEEP_DIVE_INFORMATION: 'DDI',
    NOTIFICATIONS: 'N',
    METER_VIEW: 'MV',
    LIVE_EQ: 'LEQ',
    SOLAR_RO_IN_DASHBOARD_VIEW: 'SRID',
    GENERIC_FLOW_MANAGEMENT_DASHBOARD: 'GFMD',
    MIS_SERVICE: 'MIS',
    DASHBOARD_OVERVIEW: 'DO',
    UTILITIES: 'UTI',
    KPIBENCHMARKING: 'KPIBEN',
    MACHINEMONITORING: 'MMOR',
    SOLAR_PLANT_OVERVIEW: 'SLPO',
    SOLAR_INVERTER_VIEW: 'SLIV',
    SOLAR_ARCHITECTURE_VIEW: 'SLA',
    SPECIFIC_ENERGY: 'SPE',
    TRANSFORMER_DASHBOARD: 'TRD'
  };
  public static readonly DOCUMENT_TYPE = {
    LOGO: 'Logo',
    LAYOUT: 'Layout',
    LOAD: 'Load',
    SOLAR_LAYOUT: 'Solar_Layout',
    CLICK_AND_NAVIGATE_LAYOUT: 'ClickAndNavigateLayout',
    TREE_NODE_IMAGE: 'TreeNodeImage',
    OTHER: 'Other',
    MIS_SERVICE_LOGO: 'misServiceLogo'
  };
  public static readonly WIDGET = {
    TOP_WIDGET: 'Top Widget',
    LOAD_TREE: 'Load Tree',
    LEFT_PANEL: 'Left Panel',
    LOADING_ANALYSIS: 'Loading Analysis',
    ON_TIME_ANALYSIS: 'On Time Analysis',
    ENERGY_CONSUMPTION_ANALYSIS: 'Energy Consumption Analysis',
    MAINS_POWER_FACTOR: 'Mains Power Factor',
    COMPARISION_ANALYSIS: 'Comparision Analysis',
    PEAK_POWER_ANALYSIS: 'Peak Power Analysis',
    STRATIFICATION_TANK_VIEW: 'Stratification Tank View',
    HYDRAULIC_UNIT_VIEW: 'Hydraulic Unit View',
    TRANSFORMER_MONITORING_VIEW: 'Transformer Monitoring',
    SOLAR_DASHBOARD_VIEW: 'Solar Dashboard',
    SOLAR_RO_VIEW: 'Solar RO',
    TESTBENCH_OVERVIEW: 'TestBench Overview'
  };
  public static readonly LOAD_TYPE = {
    THERMAL: { TYPE_VALUE: 'Thermal' },
    TURNING: {
      TYPE_VALUE: 'Turning',
      SUB_TYPES_VALUE_TEXT: {
        SinglePhase: 'Single Phase Motor',
        ThreePhase: 'Three Phase Motor'
      }
    },
    LIGHTING: {
      TYPE_VALUE: 'Lighting'
    },
    SWITCHING: {
      TYPE_VALUE: 'Switching'
    },
    TRANSFORMER: {
      TYPE_VALUE: 'Transformer'
    },
    GENERIC_OR_AREA_SPECIFIC_SENSOR: {
      TYPE_VALUE: 'GenericSensorLoad'
    }
  };
  public static readonly LOAD_PARAM = {
    ALL_ELECTRICAL: 'electricalParams',
    TEMPERATURE: 'temperature',
    PRESSURE: 'pressure',
    FLOW_OUTPUT: 'flowOutput',

    INVERTER_TEMPERATURE: 'inverterTemperature',
    INVERTER_RUNTIME: 'inverterRunTime',
    ALL_HARMONIC: 'harmonicParams',
    ALL_WATER: 'flowParams'
  };
  public static readonly NODE_TYPE = {
    TEXT: 'TEXT',
    METER: 'METER',
    PROCESS: 'PROCESS',
    LOAD: 'LOAD',
    VIRTUAL_GROUP: 'VIRTUAL_GROUP'
  };

  public static readonly SYSTEM_VOLTAGE = {
    kV_765: 765000,
    kV_400: 400000,
    kV_220: 220000,
    kV_132: 132000,
    kV_110: 110000,
    kV_66: 66000,
    kV_33: 33000,
    lessThan33kV: '< 33000'
  };
  public static readonly SHIFTS = [
    'firstshift',
    'secondshift',
    'nightshift',
    'fourthshift'
  ];
  public static readonly IDLE_UTILIZATION = ['utilization', 'idle'];
  public static readonly HYDRAULIC_PARAMETER_TYPE = {
    Energy: 'Energy / Power',
    Temperature: 'Temperature',
    Pressure: 'Pressure',
    FluidLevel: 'FluidLevel',
    FluidLevel_Litres: 'FluidLevel_Litres',
    EnergyFlow_GJ: 'EnergyFlow_GJ',
    FlowRate_LitrePerMin: 'FlowRate_LitrePerMin',
    FlowRate_cubicMeter: 'FlowRate_cubicMeter',
    FlowRate: 'FlowRate',
    FlowRateTotal: 'FlowRateTotal',
    FlowRateTotal_SCF: 'FlowRateTotal_SCF',
    FlowRate_cubicMeterPerHour: 'FlowRate_cubicMeterPerHour',
    Velocity_meterPerSecond: 'Velocity_meterPerSecond',
    LimitSwitch: 'LimitSwitch',
    FilterStatus: 'FilterStatus',
    Cleanliness: 'Cleanliness',
    RH: 'RH',
    BTU: 'BTU',
    RPM: 'RPM',
    Voltage: 'Voltage',
    Percentage: 'Percentage'
  };
  public static readonly ALERT_FOR_TYPE = {
    SOLAR: 'Solar',
    OTHER: 'Other'
  };
  public static readonly HYDRAULIC_OUTPUT_TYPE = {
    Modbus: 'Modbus',
    Switch: 'Switch',
    AnalogVoltage: 'Analog Voltage',
    AnalogCurrent: 'Analog Current'
  };
  public static readonly MESSAGE = {
    AddSuccessMess: 'Add new record successfuly',
    DeleteSuccessMess: 'Delete record successfuly',
    EditSuccessMess: 'Update record successfuly',
    SavingErrorMess: 'Error while saving data',
    GettingErrorMess: 'Error while getting data',
    DeletingErrorMess: 'Error while deleting data',
    LoginFail: 'Login failed.',
    PostingErrorMess: 'Error while sending data',
    Save_success: 'Save successfuly',
    Save_failure: 'Save_failure',
    Delete_success: 'Delete_success',
    Delete_failure: 'Delete_failure',
    Delete_Confirm: 'Are you sure to delete?',
    Delete_Alerts: 'Delete_Alerts',
    Token_Expired: 'token_expired'
  };
  public static readonly SENSOR_HEALTH = {
    ON: 'ON',
    OFF: 'OFF',
    NA: 'NA',
    OK: 'OK',
    NOT_OK: 'NOT OK'
  };
  public static readonly MACHINE = {
    Label_Machine_ON: 'label-machine-ON',
    Label_Machine_OFF: 'label-machine-OFF',
    Label_Data_NA: 'label-data-NA'
  };
  public static readonly INVERTER_STATUS = {
    OK: 'OK',
    Faulty: 'Faulty',
    NA: 'NA'
  };
  public static readonly TIMEBASE_ARRAY = [
    { value: 'Y', viewValue: 'Yearly' },
    { value: 'M', viewValue: 'Monthly' },
    { value: 'Q', viewValue: 'Quarterly' },
    { value: 'W', viewValue: 'Weekly' },
    { value: 'D', viewValue: 'Daily' }
  ];
  public static BOOLEAN_FALSE = false;
  public static BOOLEAN_TRUE = true;
  public static NULL_VALUE = null;
  public static one = '1';
  public static two = '2';
  public static three = '3';
  public static four = '4';
  public static FAIL = 'Fail';
  public static SUCCESS = 'Success';
  public static FUTURE_DATE_NOT_ALLOW = 'FUTURE_DATE_NOT_ALLOW';
  public static DATE_LIMIT_31_DAYS = 'DATE_LIMIT_31_DAYS';
  public static DATE_LIMIT_10_DAYS = 'DATE_LIMIT_10_DAYS';
  public static GENERATED_TIME_MSG = 'GENERATED_TIME_MSG';
  public static TO = 'TO';
  public static SEARCH = 'SEARCH';
  public static TODAY = 'TODAY';
  public static YESTERDAY = 'YESTERDAY';
  public static LAST_7_DAYS = 'LAST_7_DAYS';

  public static OPERATORS = [
    { value: '=', text: 'Equal to' },
    { value: '!=', text: 'Not Equal to' },
    { value: '>', text: 'Greater Than' },
    { value: '<', text: 'Less Than' },
    { value: '>=', text: 'Greater Than or equal to' },
    { value: '<=', text: 'Less Than or equal to' }
  ];
  public static FREQUENCIES = [
    { value: 1, text: "First Ocurrance and It's End" },
    { value: 2, text: "At Every Ocurrance and It's End" },
    { value: 3, text: 'After Every End' }
  ];
  criticalityLevels = ['Informative', 'Critical', 'Very Critical'];
}
